module.exports = __webpack_public_path__ + "img/order.48dc3f32.svg";